import { useState, useEffect } from 'react';
import {
  FISCAL_YEAR_REFRESH_EVENT,
  loadFiscalYearSelectOptions,
} from './fiscalYearUtils';

/** Live fiscal year picker options — refreshes on FISCAL_YEAR_REFRESH_EVENT. */
export function useComptabiliteFiscalYearOptions() {
  const [fiscalYearOptions, setFiscalYearOptions] = useState([]);

  useEffect(() => {
    const load = () => {
      loadFiscalYearSelectOptions()
        .then(setFiscalYearOptions)
        .catch(() => setFiscalYearOptions([]));
    };
    load();
    window.addEventListener(FISCAL_YEAR_REFRESH_EVENT, load);
    return () => window.removeEventListener(FISCAL_YEAR_REFRESH_EVENT, load);
  }, []);

  return fiscalYearOptions;
}
